import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { defaultFiltersByFolders } from "../../../Utils/utils"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getRequestsEnrollmentsFilterOptionsRequest: null,
  getRequestsEnrollmentsFilterOptionsSuccess: ["payload"], // payload: { data }
  getRequestsEnrollmentsFilterOptionsFailure: ["payload"], // payload: { data }

  getRequestsEnrollmentsRequest: ["payload"], // payload: { params }
  getRequestsEnrollmentsSuccess: ["payload"], // payload: { data }

  updateRequestsEnrollmentRequest: ["payload"], // payload: { params }
  updateRequestsEnrollmentSuccess: ["payload"], // payload: { data }

  deleteRequestsEnrollmentRequest: ["payload"], // payload: { id }
  deleteRequestsEnrollmentSuccess: ["payload"], // payload: { data }

  bulkUpdateRequestsEnrollmentRequest: ['payload'], // payload: { enrollment_request_ids, request_status?, match_type?, send_email, onSuccess, onError }
  bulkUpdateRequestsEnrollmentSuccess: ['payload'], // payload: { detail, updated_count }
  bulkUpdateRequestsEnrollmentFailure: ['payload'], // payload: { errors }

  requestsEnrollmentsFailure: ['payload'], // payload: { errors }

  clearRequestsEnrollmentsFilters: ["payload"], // payload: { data }
  requestsEnrollmentsSetProp: ["key", "value"],

  getRequestsEnrollmentsExportRequest: ["payload"], // payload: { business_id }
  getRequestsEnrollmentsExportSuccess: ["payload"], // payload: { url }
  getRequestsEnrollmentsExportFailure: ["payload"], // payload: { errors }

  logout: null
})

export const RequestsEnrollmentsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  { field_id: "created_timestamp", label: "Request date", active: true },
  { field_id: "updated_timestamp", label: "Update status date", active: true },
  //{field_id: 'request_type', label: 'Request type', active: true},
  { field_id: "is_use_another_solutions", label: "Using Competitor", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "enrollments", label: "Enrollments", active: true },
  { field_id: "merchant_descriptor", label: "Billing descriptor", active: true },
  { field_id: "visa_arn_code_date", label: "ARN Added Date", active: true },
  { field_id: "arn_codes", label: "ARN codes", active: true },
  { field_id: "bin_codes", label: "BIN codes", active: false },
  { field_id: "caid_codes", label: "CAID codes", active: false },
  { field_id: "balance_current", label: "Current Balance", active: true },
  { field_id: "another_solution_name", label: "Previous solution", active: false },
  { field_id: "previously_connected_enrollments", label: "Previously enrolled", active: false },
  {
    field_id: "is_user_notified_previous_solution",
    label: "Previous partner notified",
    active: false
  },
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "business_url", label: "Business URL", active: true },

  { field_id: "admin_comment", label: "Comment", active: true },
  { field_id: "admin_screenshots", label: "Screenshots", active: true }
]

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [{ field_id: "request_status", label: "Status" }, ...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    request_status: "all",
    created_timestamp: null,
    updated_timestamp: null,
    visa_arn_code_date: null,
    //request_type: [],
    is_use_another_solutions: "all",
    enrollments: [],
    merchant_descriptor: "all",
    arn_codes: [],
    another_solution_name: [],
    previously_connected_enrollments: [],
    is_user_notified_previous_solution: "all",
    user_full_name: [],
    user_email: [],
    business_account: [],
    business_url: [],
    exclude_fields: [],
    is_archived: null,
    admin_comment: [],
    admin_screenshots: "all",
    balance_current: { min: null, max: null, type: null }
  },

  fetchingFilterOptions: false,
  filterOptions: {
    request_status: [],
    admin_comment: []
  },

  visibleFiltersAdmin: {
    request_status: true,
    user_email: true,
    user_full_name: true,
    business_account: true
  },

  exportFetching: false,
  exportResult: null,

  saveResult: null
})

/* ------------- Selectors ------------- */

export const selectAreFiltersDefault = (state, folder) => {
  const defaultFilters = defaultFiltersByFolders.enrollments[folder] || INITIAL_STATE.filters

  const filtersToCompare = {
    ...INITIAL_STATE.filters,
    request_status: defaultFilters.request_status,
    is_archived: defaultFilters.is_archived
  }

  return isEqual(filtersToCompare, state.requestsEnrollments.filters)
}

/* ------------- Functions for reducer cases ------------- */
const getRequestsEnrollmentsFilterOptionsRequest = (state) =>
  state.merge({ fetchingFilterOptions: true })
const getRequestsEnrollmentsFilterOptionsSuccess = (state, { payload: filterOptions }) =>
  state.merge({ fetchingFilterOptions: false, filterOptions })
const getRequestsEnrollmentsFilterOptionsFailure = (state) =>
  state.merge({ fetchingFilterOptions: false })

const getRequestsEnrollmentsRequest = (state) => state.merge({ fetching: true })
const getRequestsEnrollmentsSuccess = (state, { payload: result }) => {
  if (result.results) {
    return state.merge({ fetching: false, result })
  } else {
    return state.merge({
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    })
  }
}

const updateRequestsEnrollmentRequest = (state) => state.merge({ fetching: true })
const updateRequestsEnrollmentSuccess = (state, { payload: enrollment }) => {
  let isChangedArchived = false
  let newResults = state.result.results?.map((el) => {
    if (el.id === enrollment.id) {
      if (el.is_archived !== enrollment.is_archived) isChangedArchived = true
      return { ...el, request_status: enrollment.request_status }
    }
    return el
  })

  return state.merge({
    fetching: false,
    result: {
      ...state.result,
      results: newResults
    },
    saveResult: isChangedArchived ? (enrollment.is_archived ? "archived" : "unarchived") : "updated"
  })
}

const deleteRequestsEnrollmentRequest = (state) => state.merge({ fetching: true })
const deleteRequestsEnrollmentSuccess = (state, { payload: enrollment }) => {
  let newResults = state.result.results?.filter((el) => el.id !== enrollment.id)
  return state.merge({
    fetching: false,
    result: {
      count: state.result.count - 1,
      results: newResults
    }
  })
}

const bulkUpdateRequestsEnrollmentRequest = (state) => state.merge({fetching: true})
const bulkUpdateRequestsEnrollmentSuccess = (state) => state.merge({fetching: false})
const bulkUpdateRequestsEnrollmentFailure = (state) => state.merge({fetching: false})

const requestsEnrollmentsFailure = (state) => state.merge({fetching: false})

export const requestsEnrollmentsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const clearRequestsEnrollmentsFilters = (state, { payload: data }) => {
  return state.merge({ filters: { ...INITIAL_STATE.filters, ...data } })
}

const getRequestsEnrollmentsExportRequest = (state) => state.merge({ exportFetching: true })
const getRequestsEnrollmentsExportSuccess = (state, { payload: exportResult }) =>
  state.merge({
    exportFetching: false,
    exportResult
  })
const getRequestsEnrollmentsExportFailure = (state) => state.merge({ exportFetching: false })

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_REQUEST]:
    getRequestsEnrollmentsFilterOptionsRequest,
  [Types.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_SUCCESS]:
    getRequestsEnrollmentsFilterOptionsSuccess,
  [Types.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_FAILURE]:
    getRequestsEnrollmentsFilterOptionsFailure,

  [Types.GET_REQUESTS_ENROLLMENTS_REQUEST]: getRequestsEnrollmentsRequest,
  [Types.GET_REQUESTS_ENROLLMENTS_SUCCESS]: getRequestsEnrollmentsSuccess,

  [Types.UPDATE_REQUESTS_ENROLLMENT_REQUEST]: updateRequestsEnrollmentRequest,
  [Types.UPDATE_REQUESTS_ENROLLMENT_SUCCESS]: updateRequestsEnrollmentSuccess,

  [Types.DELETE_REQUESTS_ENROLLMENT_REQUEST]: deleteRequestsEnrollmentRequest,
  [Types.DELETE_REQUESTS_ENROLLMENT_SUCCESS]: deleteRequestsEnrollmentSuccess,

  [Types.BULK_UPDATE_REQUESTS_ENROLLMENT_REQUEST]: bulkUpdateRequestsEnrollmentRequest,
  [Types.BULK_UPDATE_REQUESTS_ENROLLMENT_SUCCESS]: bulkUpdateRequestsEnrollmentSuccess,
  [Types.BULK_UPDATE_REQUESTS_ENROLLMENT_FAILURE]: bulkUpdateRequestsEnrollmentFailure,

  [Types.REQUESTS_ENROLLMENTS_FAILURE]: requestsEnrollmentsFailure,

  [Types.CLEAR_REQUESTS_ENROLLMENTS_FILTERS]: clearRequestsEnrollmentsFilters,

  [Types.REQUESTS_ENROLLMENTS_SET_PROP]: requestsEnrollmentsSetProp,

  [Types.GET_REQUESTS_ENROLLMENTS_EXPORT_REQUEST]: getRequestsEnrollmentsExportRequest,
  [Types.GET_REQUESTS_ENROLLMENTS_EXPORT_SUCCESS]: getRequestsEnrollmentsExportSuccess,
  [Types.GET_REQUESTS_ENROLLMENTS_EXPORT_FAILURE]: getRequestsEnrollmentsExportFailure,

  [Types.LOGOUT]: logout
})
